<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Validasi</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-check-circle" />
            Validasi
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            Fiducia
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card" v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang'])">
      <CCardBody class="px-0 pb-0">
        <b-row align-h="between">
          <CCol class="col-6 ml-5">
            <CForm>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="table.filterType" :options="table.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-input maxlength="50" v-if="table.filterType == 'contractNo'" type="text" placeholder="Search" v-model="table.filterValue" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"></b-form-input>
                  <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="table.filterValue"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" type="submit" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
          <!-- <CCol class="mr-3">
            <CButton color="primary" class="float-right" @click="submitValidation" v-if="$helper.isRole($availRoles['Cabang'])">
              <b-spinner small type="grow" v-if="isLoading.submitValidation" /> 
              {{ isLoading.submitValidation ? 'Sedang Diproses...' : 'Kirim Validasi' }}
            </CButton>
          </CCol> -->
        </b-row>
        <CRow class="mt-4" v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang'])">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(action)="row">
                <CButton color="warning" size="sm" @click="downloadCertificate(row.index)" class="custom-button-white mr-2">
                  <b-spinner v-if="row.item.isLoading" small type="grow" /> 
                  <CIcon v-else name="cil-data-transfer-down" />
                </CButton>
                <CButton color="primary" size="sm" class="mr-2" @click="showModal(row.index)" v-if="$helper.isRole($availRoles['Cabang'])">Validasi</CButton> 
                <CButton size="sm" color="danger" style="color: white;" @click="showRejectModal(row.item.contractId, row.item.contractNo, row.item.customerName, row.item.officeName, row.item.notaryName, row.item.collateralId)" v-if="$helper.isRole($availRoles['Cabang'])">Tolak</CButton> 
              </template>
              <!-- <template #cell(validation)="row">
                <b-form-checkbox v-model="row.item.checkValue" :disabled="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS'])" :state="row.item.checkboxState" @change="checkUncheck"></b-form-checkbox>
              </template> -->
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showValidationModal" :centered="true">
        <div slot="header"><h5>Validasi Kontrak</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Contract No"
                label-for="validate-contractNo"
              >
                <b-form-input
                  v-model="selectedItem.contractNo"
                  placeholder="Contract No"
                  maxlength="50"
                  id="validate-contractNo"
                  disabled
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="No. Akta"
                label-for="validate-deedNo"
                :state="formData.deedNo.isValid"
              >
                <b-form-input
                  v-model="formData.deedNo.value"
                  :state="formData.deedNo.isValid"
                  placeholder="No. Akta"
                  type="text"
                  maxlength="50"
                  id="validate-deedNo"
                  class="custom-input-height"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Tanggal Akta"
                label-for="validate-deedDate"
                :state="formData.deedDate.isValid"
              >
                <b-form-datepicker
                  v-model="formData.deedDate.value" 
                  id="validate-deedDate"
                  placeholder="DD/MM/YYYY"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="id"
                  :state="formData.deedDate.isValid"
                ></b-form-datepicker>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="formData.certificateNo.feedback"
                label="No. Sertifikat"
                label-for="validate-certificateNo"
                :state="formData.certificateNo.isValid"
              >
                <b-form-input
                  v-model="formData.certificateNo.value"
                  :state="formData.certificateNo.isValid"
                  placeholder="W00.00000000.AH.00.00 TAHUN 0000"
                  type="text"
                  maxlength="50"
                  id="validate-certificateNo"
                  class="custom-input-height"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Tanggal Sertifikat"
                label-for="validate-certificateDate"
                :state="formData.certificateDate.isValid"
              >
                <b-form-datepicker
                  v-model="formData.certificateDate.value" 
                  id="validate-certificateDate"
                  placeholder="DD/MM/YYYY"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="id"
                  :state="formData.certificateDate.isValid"
                ></b-form-datepicker>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showValidationModal = false">Cancel</CButton>
          <CButton class="ml-2" color="primary" type="submit" @click="confirmValidateContract" :disabled="isLoading.validateContract">
            <b-spinner small type="grow" v-if="isLoading.validateContract" />
            {{ isLoading.validateContract ? 'Loading...' : 'Validasi' }}
          </CButton>
        </div>
      </CModal>
    </CForm>

    <CModal :closeOnBackdrop="false" :show.sync="showRejectValidationModal" :centered="true">
      <div slot="header"><h5>Konfirmasi Tolak Validasi</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin tolak validasi berikut?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            No. Kontrak
          </CCol>
          <CCol md="8" sm="7">
            : {{ rejectContract.contractNo }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Nama Customer
          </CCol>
          <CCol md="8" sm="7">
            : {{ rejectContract.customerName }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Office
          </CCol>
          <CCol md="8" sm="7">
            : {{ rejectContract.officeName }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Nama Notaris
          </CCol>
          <CCol md="8" sm="7">
            : {{ rejectContract.notaryName }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showRejectValidationModal = false">Batal</CButton>
        <CButton class="ml-2" color="danger" @click="confirmRejectValidation" :disabled="isLoading.rejectValidation">
          <b-spinner small type="grow" v-if="isLoading.rejectValidation" /> 
          {{ isLoading.rejectValidation ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

  </CContainer>
</template>

<script>
export default {
  name: 'ValidationFiduciaList',
  data() {
    // W00.00000000.AH.00.00 TAHUN 0000
    const certFormat = /W[0-9]{1,2}.[0-9]{8}.AH.[0-9]{2}.[0-9]{2} TAHUN [0-9]{4}/i
    return {
      showRejectValidationModal: false,
      rejectContract: {
        contractNo: '',
        customerName: '',
        officeName: '',
        notaryName: '',
      },
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "officeName", label: "Office", sortable: true},
          {key: "notaryName", label: "Nama Notaris", sortable: true},
          {key: "action", label: "Aksi", sortable: false},
          // {key: "validation", label: "Validasi", sortable: false}
        ],

        items: [],

        filterType: "contractNo",
        filterOptions: [
          { value: "contractNo", text: "No. Kontrak" },
          { value: "customerName", text: "Nama Customer" },
          { value: "officeName", text: "Office" },
          { value: "notaryName", text: "Nama Notaris" }
        ],
        filterValue: "",

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      isLoading: {
        submitValidation: false,
        validateContract: false,
        rejectValidation: false,
      },
      showValidationModal: false,
      
      selectedItem: {
        contractId: 0,
        contractNo: 0,
        collateralId: 0,
      },

      formData: {
        deedNo: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "deedNo"
        },

        deedDate: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "deedDate"
        },

        certificateNo: {
          value: '',
          isValid: null,
          feedback: 'This input is required.',
          format: certFormat,
          isRequired: true,
          payloadKey: "certificateNo"
        },
        
        certificateDate: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "certificateDate"
        },
      }
    }
  },
  methods: {

    confirmRejectValidation() {
      this.isLoading.rejectValidation = true
      let processUrl = "/contract/fiducia/rejectCertificate";
      let data = new FormData();
      data.set('contractId', this.rejectContract.contractId);
      data.set('collateralId', this.rejectContract.collateralId);
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          this.$helper.toastSuccess(this, "Tolak Validasi sukses!")
          this.showRejectValidationModal = false
        } else {
          this.$helper.toastError(this, "Tolak Validasi Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Tolak Validasi Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Tolak Validasi Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.rejectValidation = false

        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.getTableItems(this.table.currentPage)
        }
      })
    },

    showRejectModal(contractId, contractNo, customerName, officeName, notaryName, collateralId) {
      this.rejectContract.contractId = contractId
      this.rejectContract.collateralId = collateralId
      this.rejectContract.contractNo = contractNo
      this.rejectContract.customerName = customerName
      this.rejectContract.officeName = officeName
      this.rejectContract.notaryName = notaryName

      this.showRejectValidationModal = true
    },

    showModal(index) {
      this.selectedItem.contractId = this.table.items[index].contractId
      this.selectedItem.contractNo = this.table.items[index].contractNo
      this.selectedItem.collateralId = this.table.items[index].collateralId
      
      this.resetFormDataFields()
      this.showValidationModal = true
    },

    filterTable(event) {
      event.preventDefault()

      this.getTableItems(this.table.currentPage)
    },

    checkUncheck(checked) {
      this.table.items.forEach(obj => {
        obj.checkboxState = null
      })
    },

    resetFormDataFields() {
      for(const [key, data] of Object.entries(this.formData)){
        data.isValid = null
        data.value = ''
      }
    },

    confirmValidateContract(event) {
      event.preventDefault()

      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.formData)){
        if(key == "certificateNo"){
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            data.feedback = "This input is required."
            data.isValid = false
            isFormValid = false
          }
          else if (!data.format.test(data.value)){
            data.feedback = "Invalid Certificate Number."
            data.isValid = false
            isFormValid = false
          }
          else {
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
        }
        else{
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.isValid = false
            isFormValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
        }
      }

      if(isFormValid){
        let postUrl = "/contract/fiducia/validateCertificate"
        obj['contractId'] = this.selectedItem.contractId
        obj['collateralId'] = this.selectedItem.collateralId
        obj['contractNo'] = this.selectedItem.contractNo
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.isLoading.validateContract = true

          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Validasi Kontrak Berhasil!")
              this.showValidationModal = false

              this.getTableItems(this.table.currentPage)
            }
            else{
              this.$helper.toastError(this, "Validasi Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Validasi Kontrak Gagal! " + (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Validasi Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isLoading.validateContract = false
          })
        } else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },

    downloadCertificate(index) {
      let collateralId = this.table.items[index].collateralId

      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['Cabang'])){

        this.table.items[index].isLoading = true
        let processUrl = "/contract/fiducia/downloadCertificate"
        let data = new FormData()
        data.set('collateralId', collateralId)
        this.$axios.post(processUrl, data, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then((response) => {
          if (response.status === 200){

            // create file Blob and download according to extension
            let blob = new Blob([response.data], { type: "application/octet-stream" })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'contract_' + collateralId + '.pdf'
            link.click()

            this.$helper.toastSuccess(this, "Download Sertifikat Sukses! " + (response.data.reason ? response.data.reason : ""))
          } else {
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          // console.log(error)
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Sertifikat Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
        this.table.items[index].isLoading = false
        })
      }
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['Cabang'])){
        this.getTableItems(this.table.currentPage)
      }
    },

    onChangeFilterType() {
      this.table.filterValue = null
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['Cabang'])){
        this.getTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['Cabang'])){
        this.getTableItems(newPage)
      }
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/contract/fiducia/getCollateralForValidation"

      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(!this.$helper.isEmpty(this.table.filterValue)) {
        params['filterType'] = this.table.filterType
        params['filterValue'] = this.table.filterValue
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }
      
      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterValidationFiduciaType", this.table.filterType)
          sessionStorage.setItem("filterValidationFiduciaValue", this.table.filterValue)
          // sessionStorage.setItem("filterValidationSortBy", this.table.sort.by)
          // sessionStorage.setItem("filterValidationAsc", this.table.sort.desc)
          this.table.items = response.data.data.data.map(obj => {
            obj.isLoading = false
            obj.checkValue = false
            obj.checkboxState = null

            return obj
          })
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Validasi Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Validasi Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Validasi Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

  },

  created(){
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterValidationFiduciaType"))){
      this.table.filterType = sessionStorage.getItem("filterValidationFiduciaType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterValidationFiduciaValue"))){
      this.table.filterValue = sessionStorage.getItem("filterValidationFiduciaValue")
    }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterValidationSortBy"))){
    //   this.table.sort.by = sessionStorage.getItem("filterValidationSortBy")
    // }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterValidationAsc"))){
    //   this.table.sort.desc = (sessionStorage.getItem("filterValidationAsc") === 'true' ? true : false)
    // }
    this.getTableItems()
  },
}
</script>